export default "__VITE_ASSET__BlRRTeq6__"